import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Partners from "@/pages/Partners";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import Diagnostic from "@/pages/Diagnostic";
import DiagnosticResults from "@/pages/DiagnosticResults";
import Scenarios from "@/pages/Scenarios";
import ScenarioRun from "@/pages/ScenarioRun";
import Lessons from "@/pages/Lessons";
import LessonDetail from "@/pages/LessonDetail";
import Journal from "@/pages/Journal";
import SystemDashboard from "@/pages/SystemDashboard";
import PartnersAdmin from "@/pages/PartnersAdmin";
import AppShell from "@/components/AppShell";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-16 text-center text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/diagnostic" element={<Protected><Diagnostic /></Protected>} />
          <Route path="/app/diagnostic/results" element={<Protected><DiagnosticResults /></Protected>} />
          <Route path="/app/scenarios" element={<Protected><Scenarios /></Protected>} />
          <Route path="/app/scenarios/:id" element={<Protected><ScenarioRun /></Protected>} />
          <Route path="/app/lessons" element={<Protected><Lessons /></Protected>} />
          <Route path="/app/lessons/:id" element={<Protected><LessonDetail /></Protected>} />
          <Route path="/app/journal" element={<Protected><Journal /></Protected>} />
          <Route path="/app/system" element={<Protected><SystemDashboard /></Protected>} />
          <Route path="/app/partners-admin" element={<Protected><PartnersAdmin /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
